<template>
    <div class="xcard">
        <h4 class="text-center"><b> {{titletexto}} </b></h4>
        <div style="background-color: #E8F5FD;" class="pa-4">
            <p><b>Codigo de Programa:</b> {{formatCode(postgrado.nombre,newprograma.programa_id)}} </p>
            <p><b>El postgrado seleccionado es:</b> {{postgrado.nombre}} </p>
            <p><b>Categoria:</b> {{postgrado.categoria.nombre}} </p>
            <p><b>Area:</b> {{postgrado.area.nombre}} </p>
            <p><b>Objetivo:</b> {{postgrado.objetivo}}  </p>
            <p><b>Dirigido:</b> {{postgrado.dirigido}}  </p>
            <p><b>Carga horaria:</b> {{postgrado.carga_horaria}} horas.  </p>
            <p><b>Duracion:</b> {{parseDuracion()}}.  </p>
        </div>
        <hr>

        <div class="text-center">
            <div style="display: inline-block;" v-show="loading" class="loader"></div> 
        </div>
        <div>
            <p class="text-center text-primary">Formulario de datos del programa</p>
            <div class="row" style="background-color:#E1F5E0;">
                <div class="col-sm-6">
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Programa</div>
                            <input type="text" class="form-control" v-model.trim="newprograma.nombre_compuesto">
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Sede</div>
                            <Sedes :model="sedesel" :default="$store.state.CARGO.sede" :bycargos="true"/>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <label> <input type="checkbox" v-model="tiene_auspicio"> Auspiciante/Convenio <small>(Si este programa no tiene auspiciante o convenio desmarque esta casilla)</small> </label>
                        <div class="input-group input-group-sm" v-show="tiene_auspicio">
                            <div class="input-group-addon"> Convenio/Auspicio </div>
                            <Universidades :model="universidadsel" v-bind:convenio="true" :xdefault="newprograma.universidad_id"/>
                        </div>
                        <p class="text-primary text-center" v-show="!tiene_auspicio"> Este programa no tiene convenio/auspicio con ninguna institucion. </p>
                    </div>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Gestion</div>
                            <Gestiones :model="gestionsel" :default="defaultgestion"/>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Version</div>
                            <input type="number" class="form-control" v-model.number="newprograma.version">
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Grupo</div>
                            <input type="number" class="form-control" v-model.number="newprograma.grupo">
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Modalidad</div>
                            <select v-model="newprograma.modalidad" class="form-control">
                                <option value="S">Semi presencial</option>
                                <option value="P">Presencial</option>
                                <option value="V">Virtual</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Nota minima de aprobacion</div>
                            <input type="number" class="form-control" v-model.number="newprograma.nota_aprobacion">
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Plataforma moodle:</div>
                            <Plataformas :model="plataformasel" :xdefault="newprograma.plataforma_id"/>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Coordinador:</div>
                            <Usuarios :current='false' :model="coordinadorsel" :xdefault="newprograma.coordinador.coordinador_id"/>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Responsable:</div>
                            <Usuarios :current='false' :model="responsablesel" :xdefault="newprograma.responsable.responsable_id"/>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Inicio</div>
                            <Fecha :model="newprograma" :valueto="'fecha_inicio'" :default="modificar.fecha_inicio"/>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Finalizacion</div>
                            <Fecha :model="newprograma" :valueto="'fecha_fin'" :default="modificar.fecha_fin"/>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div class="row" style="background-color:#E1F5E0;">
                <div class="col-sm-4 col-sm-offset-2">
                    <p> <b>Seleccione un archivo y luego presione el boton de subir portada</b> </p>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Portada</div>
                            <input type="file" id="portadafile" :disabled="cargandoportada" accept="image/*" @change="portadaselect">
                        </div>
                        <button class="btn btn-azul btn-sm" :disabled="portadasel" @click="subirportadaselect()">subir portada</button> <span v-show="cargandoportada" class="text-success"> subiendo... </span> <span v-show="subidoportada" class="text-primary"> portada subida. </span>
                        <div style="display: inline-block;" v-show="cargandoportada" class="loader"></div> 
                        <img v-if="newprograma.portada" class="img-responsive" alt="Portada" :src="location_programa_portadas+newprograma.portada">
                    </div>
                </div>

                <div class="col-sm-4">
                    <p> <b>Seleccione un archivo y luego presione el boton de subir certificado</b> </p>
                    <div class="form-group form-group-sm">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Certificado</div>
                            <input type="file" id="certificadofile" :disabled="cargandocertificado" accept="image/*" @change="certificadoselect">
                        </div>
                        <button class="btn btn-azul btn-sm" :disabled="certificadosel" @click="subircertificadoselect()">subir certificado</button> <span v-show="cargandocertificado" class="text-success"> subiendo... </span> <span v-show="subidocertificado" class="text-primary"> certificado subido. </span>
                        <div style="display: inline-block;" v-show="cargandocertificado" class="loader"></div> 
                        <img v-if="newprograma.arte" class="img-responsive" alt="certificado" :src="location_certificado_programa+newprograma.arte">
                    </div>
                </div>
            </div>

            <hr>
            <p class="text-primary text-center"> Asignacion de modulos al programa </p>
            <p>
                <small class="text-primary">Agregar o quitar modulos: </small>
                <a href="#" class="btn btn-link btn-sm" @click="addmoduloview"> <span class="glyphicon glyphicon-plus"></span> </a>
                <a href="#" class="btn btn-link btn-sm" @click="delmoduloview"> <span class="glyphicon glyphicon-minus"></span> </a>
                <a class="btn btn-link btn-sm" style="margin-left:84px" role="button" data-toggle="collapse" href="#collapseExamplem" aria-expanded="false" aria-controls="collapseExample">
                    <span class="glyphicon glyphicon-chevron-down"></span> Crear Nuevo Modulo si No existe (opcional)
                </a>
            </p>
            <div class="collapse" id="collapseExamplem">
                <NewModulo />
            </div>
            <div class="row" style="background-color: #FAE9F3;">
                <div class="col-sm-12">
                    <div :key="ind" v-for="(r, ind) in newprograma.modulos">
                        <div class="row" style="margin-bottom: 4px">
                            <div class="col-sm-1">
                                <input class="form-control input-sm" maxlength="5" type="number" v-model="r.numero" placeholder="numero de modulo" required="true" />
                            </div>
                            <div class="col-sm-4">
                                <AModulos :model="r" :zdefault="r"/>
                            </div>
                            <div class="col-sm-2">
                                <Fecha :model="r" :valueto="'xfecha_inicio'" :default="r.xfecha_inicio"/>
                            </div>
                            <div class="col-sm-2">
                                <Fecha :model="r" :valueto="'xfecha_fin'" :default="r.xfecha_fin"/>
                            </div>
                            <div class="col-sm-3">
                                <BuscarDocente :model="r" :onlyid="true"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>








            <hr>
            <p class="my-0"><b>Codigo Programa:</b> {{formatCode(postgrado.nombre,newprograma.programa_id)}} </p>
            <p class="text-primary text-center"> Plan de pagos del Programa/Curso <small>(Estos datos son referenciales para la inscripcion)</small> </p>
            <p>
                <small class="text-primary">Plan de pagos: </small>
                <a href="#" class="btn btn-link btn-sm" @click="addplanview"> <span class="glyphicon glyphicon-plus"></span> </a>
                <a href="#" class="btn btn-link btn-sm" @click="delplanview"> <span class="glyphicon glyphicon-minus"></span> </a>
            </p>
            <div class="row">
                <div class="col-sm-12" :key="indi" v-for="(p, indi) in newprograma.planes">
                    <span v-if="p.nombre">Detalle del plan: <b>{{p.nombre}}</b></span>
                    <span v-else class="text-danger"> Presione el boton <b>+</b> para agregar un nombre al plan y los conceptos de pagos...  </span>
                    <div class="row" style="background-color: #DBFFDC;">
                        <div class="col-sm-10 col-sm-offset-2">
                            <p style="margin-bottom:0" v-show="p.xestado==null">
                                <small class="text-primary">Conceptos de pago: </small>
                                <a href="#" class="btn btn-link btn-sm" @click="addcobroview(p)"> <span class="glyphicon glyphicon-plus"></span> </a>
                                <a href="#" class="btn btn-link btn-sm" @click="delcobroview(p)"> <span class="glyphicon glyphicon-minus"></span> </a>
                            </p>
                            <div v-if="p.cobros.length">
                                <p v-if="p.xestado != null"> Estado del plan: <input type="checkbox" v-model="p.xestado"> <small v-show="!p.xestado" class="text-danger">Este plan sera deshabilitado</small> </p>
                                <b>Nombre del plan: </b> 
                                <input v-if="p.xestado==null" :disabled="p.xestado!=null" type="text" class="xinput" v-model="p.nombre" placeholder="ej: al contado, al credito">
                                <span v-else class="text-danger" style="margin-right:32px"> <b>{{p.nombre}}</b> </span>
                            </div>
                            <div :key="ind" v-for="(r, ind) in p.cobros">
                                <div class="row">
                                    <div class="col-sm-3" style="margin-bottom:0;margin-top:0;padding-bottom:0;padding-top:2px">
                                        <b v-if="r.xdisabled"> {{r.xnombre}}: </b>
                                        <AConceptospago :model="r" :xdefault="r" v-else/>
                                    </div>
                                    <div class="col-sm-3" style="margin-bottom:0;margin-top:0;padding-bottom:0;padding-top:2px">
                                        <input :disabled="r.xdisabled" class="form-control input-sm" maxlength="5" type="number" v-model.number="r.monto" placeholder="monto (Bs)" required="true" />
                                    </div>
                                    <div class="col-sm-3" style="margin-bottom:0;margin-top:0;padding-bottom:0;padding-top:2px">
                                        <input :disabled="r.xdisabled" class="form-control input-sm" maxlength="5" type="number" v-model.number="r.cuotas" placeholder="cantidad de cuotas" required="true" />
                                    </div>
                                    <div v-show="false" class="col-sm-3" style="margin-bottom:0;margin-top:0;padding-bottom:0;padding-top:2px" title="Marque esta opcion cuando el cobro no es obligatorio, por ejemplo un curso es gratuito pero para optener el certificado debe pagar, en este caso no todos pagaran por el certificado.">
                                        <input :disabled="r.xdisabled" class="" type="checkbox" v-model="r.opcional"/> Cobro opcional 
                                    </div>
                                </div>
                            </div>

                            <div class="text-danger">
                                <small><b>NOTA: </b> Una ves guardado el programa no se podra editar los montos de los conceptos de pago, asegurese de registrar correctamente los montos y cuotas.</small>
                            </div>
                        </div>
                    </div>

                </div>
                <small v-show="cuotasfalse"> Hay {{cuotasfalse}} planes que han sido deshabilitados.  </small>
            </div>


            <p class="text-center text-danger"> {{msg}} </p>
            <div class="text-center">
                <div style="display: inline-block;" v-show="loading" class="loader"></div> 
            </div>
            <button class="center-block btn btn-sm btn-success" :disabled="loading" @click="prepararnewprograma()"> {{btntexto}} </button>
        </div>

    </div>
</template>

<script>
import Sedes from '@/components/ASedes.vue'
import Universidades from '@/components/AUniversidades.vue'
import Gestiones from '@/components/AGestiones.vue'
import Fecha from '@/components/AFecha'
import Plataformas from '@/components/APlataformas'
import Usuarios from '@/components/AUsuariosActivos'
import AModulos from '@/components/ASelecionar-modulo'
import BuscarDocente from '@/components/ABuscarDocentes.vue'
import NewModulo from '@/components/AModulosCrear'
import AConceptospago from '@/components/AConceptospago'
import {getheadersrest} from '@/components/Utils'

export default {
    data(){
        return{
            location_certificado_programa: process.env.VUE_APP_URL_CERT_PROGRAMAS,
            location_programa_portadas: process.env.VUE_APP_URL_PORTADAS,
            msg:'',
            numeroinicio:0,
            sedesel:{},
            universidadsel:{iduniversidad:null},
            gestionsel:{},
            plataformasel:{},
            postgrado:{categoria:{},area:{}},
            coordinadorsel:{idusuario:null},
            responsablesel:{},
            cargandoportada:false,
            subidoportada:false,
            portadasel: true,
            cargandocertificado:false,
            subidocertificado:false,
            certificadosel: true,
            loading: false,
            modificar:{fecha_inicio:null,fecha_fin:null},
            btntexto:'Registrar nuevo programa',
            titletexto:'Registro de nuevo Programa',
            cuotasfalse: 0,
            tiene_auspicio: true,
            defaultgestion:{gestion:null},
            newprograma:{
                "nombre_compuesto": "",
                "posgrado_id": 0,
                "version": null,
                "grupo": null,
                "modalidad": "",
                "fecha_inicio": null, // puede ser null
                "fecha_fin": null,// puede ser null
                "sede_id": 0,
                "universidad_id": null,// puede ser null
                "gestion": 0,
                "portada": "",
                "fase": null,// puede ser null
                "arte": null,// puede ser null
                "modulo_finalizado": null,// puede ser null
                "nota_aprobacion": 71,
                "plataforma_id": null,// puede ser null
                "course_category_id": null,// puede ser null
                "modulos": [
                    /*{
                        "modulo_id": 0,
                        "docente_id": 0,// puede ser null
                        "numero": 0,
                        "fecha_inicio": "",// puede ser null
                        "fecha_fin": "",// puede ser null
                        "estado": 0// puede ser null
                    }*/
                ],
                "planes":[],
                "cobros": [ // esto ya no va
                    /*{
                        "concepto_pago_id": 0,
                        "monto": 0,
                        "cuotas": 0
                    }*/
                ],// puede ser null
                "coordinador": {
                    "coordinador_id": 0
                },// puede ser null
                "responsable": {
                    "responsable_id": 0
                }// puede ser null
            }
        }
    },
    watch: {
        
    },
    components:{Sedes,Universidades,Gestiones,Fecha,Plataformas,Usuarios,AModulos,BuscarDocente,NewModulo,AConceptospago},
    methods:{
        parseDuracion(){
            let u = this.postgrado.unidad_duracion;
            let d = this.postgrado.duracion;
            if( u == 0 ) return d+' meses';
            else if( u == 1 ) return d+' semanas';
            else if( u == 2 ) return d+' dias';
            else if( u == 3 ) return d+' horas';
            return '-';
        },
        portadaselect(){
            this.portadasel = false;
            this.subidoportada = false;
        },
        certificadoselect(){
            this.certificadosel = false;
            this.subidocertificado = false;
        },
        subirportadaselect(){
            const vue = this;
            this.cargandoportada = true;
            this.subidoportada = false;
            // window.console.log( 'Hola subiendo....' );

            let photo = document.getElementById("portadafile").files[0];
            let formData = new FormData();
            let date = new Date().getTime();
            let myHeaders = getheadersrest();

            formData.append("file", photo);
            formData.append("nombre", 'portada-'+date+'.jpg');
            let url = `${process.env.VUE_APP_URL_WEBDATA}portada_upload.php`;
            fetch(url, {method: "POST",headers: myHeaders, body: formData})
            .then(response => response.json())
            .then(result => {
                // window.console.log( 'RESULTADO:', result );
                vue.cargandoportada = false;
                if( result.status ){
                    vue.subidoportada = true;
                    vue.newprograma.portada = result.newCertName;
                }
                // window.console.log('IMAGES:::',result,vue.recibo);
            })
            .catch(() => {
                // window.console.log('error>>', error);
            });
        },
        subircertificadoselect(){
            const vue = this;
            this.cargandocertificado = true;
            this.subidocertificado = false;
            // window.console.log( 'Hola subiendo....' );

            let photo = document.getElementById("certificadofile").files[0];
            let formData = new FormData();
            let date = new Date().getTime();
            let myHeaders = getheadersrest();

            formData.append("file", photo);
            formData.append("nombre", 'certificado-'+date+'.jpg');
            let url = `${process.env.VUE_APP_URL_WEBDATA}certificado_upload.php`;
            fetch(url, {method: "POST",headers: myHeaders, body: formData})
            .then(response => response.json())
            .then(result => {
                // window.console.log( 'RESULTADO:', result );
                vue.cargandocertificado = false;
                if( result.status ){
                    vue.subidocertificado = true;
                    vue.newprograma.arte = result.newCertName;
                }
                // window.console.log('IMAGES:::',result,vue.recibo);
            })
            .catch(() => {
                // window.console.log('error>>', error);
            });
        },
        addmoduloview(){
            let num = this.newprograma.modulos.length+this.numeroinicio;
            //if( this.newprograma.modulos.length > 0 ) num += 1;
            this.newprograma.modulos.push({ numero:num,modulo_id: null, docente_id: null, fecha_inicio: null, fecha_fin: null,estado:1 });
        },
        delmoduloview(){
            this.newprograma.modulos.pop();
        },

        addcobroview( plan ){
            plan.cobros.push({ concepto_pago_id:null,monto:null,cuotas:null,opcional:false });
        },
        delcobroview( plan ){
            plan.cobros.pop();
        },

        addplanview(){
            this.newprograma.planes.push({ nombre:null,cobros:[] });
        },
        delplanview(){
            this.newprograma.planes.pop();
        },
        parsefechaguiones( f ){ // devuelve formato: DD/MM/YYYY
            if( !f.includes('-') ) return f; // ya fue parseado
            // window.console.log( 'parse fechita:',f )
            let fs = f.split('-');
            return fs[2]+'/'+fs[1]+'/'+fs[0];
        },
        prepararnewprograma(){
            let obj = window.Object.assign({},this.newprograma );
            this.msg = '';
            this.$store.state.obj = obj;
            this.$store.dispatch('quitarNulos');
            delete obj.coordinador;
            delete obj.responsable;
            //if( !obj.planes.cobros ) delete obj.planes.cobros;

            //window.console.log( window.stringifyObject(obj) );

            if( this.tiene_auspicio && !this.universidadsel.iduniversidad ){
                this.msg = 'Debe seleccionar la universidad/institucion de auspicio/convenio, o desmarque la casilla.'
                return;
            }

            if( this.sedesel.idsede ) obj.sede_id = this.sedesel.idsede.id;
            if( this.gestionsel.gestion ) obj.gestion = this.gestionsel.gestion.gestion;
            if( this.universidadsel.iduniversidad ) obj.universidad_id = this.universidadsel.iduniversidad.id;
            if( this.plataformasel.plataforma ) obj.plataforma_id = this.plataformasel.plataforma.id;
            if( this.coordinadorsel.idusuario ) obj.coordinador = {coordinador_id:this.coordinadorsel.idusuario.id};
            if( this.responsablesel.idusuario ) obj.responsable = {responsable_id:this.responsablesel.idusuario.id};
            if( obj.responsable && !obj.responsable.responsable_id ) delete obj.responsable;
            if( obj.coordinador && !obj.coordinador.coordinador_id ) delete obj.coordinador;
            if( obj.modulos ){
                let modulosvalido = true;
                const vue = this;
                obj.modulos.forEach(function(e){
                    if( !e.xfecha_inicio ) delete e.xfecha_inicio;
                    if( !e.xfecha_fin ) delete e.xfecha_fin;
                    if( !e.docente_id ) delete e.docente_id;
                    if( e.numero == null ) modulosvalido = false;
                    else{ e.numero = parseInt(e.numero)}
                    if( !e.modulo_id ) modulosvalido = false;
                    else if( e.xfecha_inicio && !e.xfecha_fin ) modulosvalido = false;
                    else if( !e.xfecha_inicio && e.xfecha_fin ) modulosvalido = false;
                    if( e.xfecha_inicio ) e.fecha_inicio = vue.parsefechaguiones( e.xfecha_inicio );
                    if( e.xfecha_fin ) e.fecha_fin = vue.parsefechaguiones( e.xfecha_fin );
                });
                if( !modulosvalido ){
                    this.msg = 'Los modulos no son validos, asegurese que todos tengan numero, modulo seleccionado y debe registrar las dos fechas(inicio y final) o no registrar ninguna';
                    return;
                }
            }
            if( obj.planes ){
                let cobrosvalido = true;
                let planesvalido = true;
                let nombresconceptos = [];
                obj.planes.forEach(function(p){
                    nombresconceptos.push( p.nombre.toLowerCase().replace(/ +(?= )/g,'') )
                    if( !p.nombre ) planesvalido = false;
                    else if( !p.nombre.length ) planesvalido = false;

                    if( p.cobros ){
                        p.cobros.forEach(function(e){
                            if( e.concepto_pago_id == null ) cobrosvalido = false;
                            else if( e.monto == null || e.monto == 0 ) cobrosvalido = false;
                            else if( e.cuotas == null || e.cuotas == 0 ) cobrosvalido = false;
                        });
                        if( p.cobros.length == 0 ) planesvalido = false;
                    }
                });
                let findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) != index)
                let duplis = findDuplicates(nombresconceptos);
                //window.console.log( 'DUPLICADOS:',findDuplicates(nombresconceptos) );
                if( duplis.length > 0 ){
                    this.msg = 'No se permite nombres de planes duplicados: '+duplis.toString();
                    return;
                }

                if( !cobrosvalido ){
                    this.msg = 'Los conceptos no son validos, asegurese de llenar todos los campos de cada concepto, tampoco se aceptan montos o las cuotas con valor 0(cero).';
                    return;
                }
                if( !planesvalido ){
                    this.msg = 'El plan de pagos no es valido, cada plan de pagos debe tener al menos un concepto de pago y su nombre de cada plan';
                    return;
                }
                if( obj.planes.length == 0 ){
                    this.msg = 'Debe ingresar los planes de pago para este programa, como ser al contado, al credito, u otros planes.';
                    return;
                }
            }
            if( obj.fecha_inicio ){
                let fs1 = obj.fecha_inicio.split('-');
                obj.fecha_inicio = fs1[2]+'/'+fs1[1]+'/'+fs1[0];
            }
            if( obj.fecha_fin ){
                let fs2 = obj.fecha_fin.split('-');
                obj.fecha_fin = fs2[2]+'/'+fs2[1]+'/'+fs2[0];
            }
            if( !obj.nombre_compuesto.endsWith(')') ) obj.nombre_compuesto += ` (V${obj.version} G${obj.grupo} ${obj.gestion} S${obj.sede_id})`;

            //obj.portada = 'portaditademos.jpg';
            

            //window.console.log( window.stringifyObject(obj) );
            

            if( !obj.nombre_compuesto ) { this.msg = 'Debe ingresar el nombre del programa'; return; }
            if( !obj.posgrado_id ) { this.msg = 'Debe seleccionar un postgrado'; return; }
            if( !obj.version ) { this.msg = 'Debe ingresar la version del programa'; return; }
            if( !obj.grupo ) { this.msg = 'Debe ingresar el grupo del programa'; return; }
            if( !obj.modalidad ) { this.msg = 'Debe seleccionar modalidad del programa'; return; }
            if( !obj.sede_id ) { this.msg = 'Debe seleccionar la sede del programa'; return; }
            if( !obj.gestion ) { this.msg = 'Debe ingresar la gestion del programa'; return; }
            if( !obj.nota_aprobacion ) { this.msg = 'Debe ingresar nota de aprobacion del programa'; return; }
            if( !obj.portada ) { this.msg = 'Debe subir la portada del programa'; return; }
            if( !obj.modulos ) { this.msg = 'Debe seleccionar los modulos del programa'; return; }

            this.dialogoconfirm( obj );
        },
        dialogoconfirm( obj ){
            // eliminamos los planes sino se duplican
            // si tiene el atributo  xdisabled es plan que ya tenia el programa
            // si no tiene el xdisabled entonces es un nuevo plan que se esta agregando
            if( obj.programa_id ){ 
                if( obj.planes ){
                    let plns = [];
                    let updatesplanes = [];
                    obj.planes.forEach(function(p){
                        let pl = window.Object.assign({},p);
                        pl.cobros = [];
                        p.cobros.forEach(function(c){
                            if( !c.xdisabled ){
                                pl.cobros.push( c );
                            }
                        });
                        if( p.xplan_cobro_programa_id ){
                            updatesplanes.push({ plan_cobro_programa_id: p.xplan_cobro_programa_id,nombre: p.nombre,estado: p.xestado });
                        }
                        if( pl.cobros.length ) plns.push( pl );
                    });
                    obj.planes = plns;
                    obj.modificar_planes = updatesplanes;
                }
            }
            // window.console.log( '\n',JSON.stringify(obj,null,4) );
            const vue = this;
            this.$dialog.confirm(this.$store.state.alertmsg).then(function() { 
                if( obj.programa_id ){
                    if( !obj.fase ) obj.fase = 0;
                    // window.console.log( '\nMOD>>>>',JSON.stringify(obj) );
                    vue.modificarprogramarest( obj );
                }else{
                    // window.console.log( '\nNEW>>>>',JSON.stringify(obj) );
                    vue.crearprogramarest( obj );
                }
            }).catch(function() {});
        },
        crearprogramarest( obj ){
            this.loading = true;
            const vue = this;
            let myHeaders = getheadersrest();

            var raw = JSON.stringify(obj);

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            let urlacademico = process.env.VUE_APP_API_REST+`/esam/programa`;
            fetch(urlacademico, requestOptions)
            .then(response => response.json())
            .then(result => {
                // window.console.log(result);
                if( !result ){
                    vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO REGISTRAR EL PROGRAMA.'
                }else{
                    if( result.error ){
                        vue.msg = result.error;
                    }else{
                        vue.msg = 'El programa fue creado.';
                    }
                }
                vue.loading = false;
            })
            .catch(() => {
                // window.console.log('error', error);
                vue.loading = false;
            });
        },
        modificarprogramarest( obj ){
            this.loading = true;
            const vue = this;
            let myHeaders = getheadersrest();

            var raw = JSON.stringify(obj);

            var requestOptions = {
                method: 'PUT',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            let urlacademico = process.env.VUE_APP_API_REST+`/esam/programa`;
            fetch(urlacademico, requestOptions)
            .then(response => response.json())
            .then(result => {
                // window.console.log(result);
                if( !result ){
                    vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO MODIFICAR EL PROGRAMA.'
                }else{
                    if( result.error ){
                        vue.msg = result.error;
                    }else{
                        vue.msg = 'El programa fue modificado.';
                    }
                }
                vue.loading = false;
            })
            .catch(() => {
                // window.console.log('error', error);
                vue.loading = false;
                vue.msg = 'Intente nuevamente, si el fallo persiste contacte con sistemas.';
            });
        },
        getprogramatoedit( idprograma ){
            this.loading = true;
            const vue = this;
            let myHeaders = getheadersrest();
            var requestOptions = {
                method: 'GET',
                redirect: 'follow',
                headers: myHeaders,
            };

            let urlacademico = process.env.VUE_APP_API_REST+`/esam/programa/id/${idprograma}`;
            fetch(urlacademico, requestOptions)
            .then(response => response.json())
            .then(result => {
                // window.console.log('GET PROGRMA:',result);
                if( !result ){
                    vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO OBTENER DATOS DEL PROGRAMA.'
                }else if( result.error ){
                    vue.msg = result.error;
                }else{
                    //vue.msg = 'El programa fue recuperado....';
                    vue.btntexto = 'Actualizar datos del programa';
                    vue.titletexto = 'Actualizar datos del programa';
                    vue.newprograma.programa_id = result.programa_id; // flag para editar programa
                    let indiceparentesis = result.nombre_compuesto.indexOf('(')
                    if( indiceparentesis > 0 ){
                        let text = result.nombre_compuesto.substring(0,indiceparentesis);
                        vue.newprograma.nombre_compuesto = text.trim();
                    }else{
                        vue.newprograma.nombre_compuesto = result.nombre_compuesto;
                    }
                    vue.newprograma.posgrado_id = result.posgrado_id;
                    vue.newprograma.version = result.version;
                    vue.newprograma.grupo = result.grupo;
                    if( result.modalidad == 'SEMIPRESENCIAL') vue.newprograma.modalidad = 'S';
                    else if( result.modalidad == 'PRESENCIAL') vue.newprograma.modalidad = 'P';
                    else if( result.modalidad == 'VIRTUAL') vue.newprograma.modalidad = 'V';
                    if( result.responsable ) vue.newprograma.responsable = {responsable_id:result.responsable.responsable_id};
                    if( result.coordinador ) vue.newprograma.coordinador = {coordinador_id:result.coordinador.coordinador_id};
                    vue.newprograma.fecha_inicio = result.fecha_inicio;
                    vue.newprograma.fecha_fin = result.fecha_fin;
                    vue.newprograma.sede_id = result.sede_id;
                    vue.newprograma.universidad_id = result.universidad_id;
                    vue.newprograma.gestion = result.gestion;
                    vue.newprograma.portada = result.portada;
                    vue.newprograma.fase = result.fase;
                    vue.newprograma.arte = result.arte;
                    vue.newprograma.modulo_finalizado = result.mod_finalizado;
                    vue.newprograma.nota_aprobacion = result.nota_aprobacion;
                    vue.newprograma.plataforma_id = result.plataforma_id;
                    vue.newprograma.fase = result.fase;
                    //vue.newprograma.course_category_id = result.id;
                    vue.newprograma.modulos = [];
                    vue.newprograma.cobros = [];
                    if( result.programa_modulo ){
                        const pm = [];
                        result.programa_modulo.forEach(function(e){
                            pm.push( 
                                {modulo_id:e.modulo_id,docente_id:null,nombre:e.nombre,numero:e.numero,xfecha_inicio:e.fecha_inicio,xfecha_fin:e.fecha_fin,estado:1}
                            )
                        })
                        vue.newprograma.modulos = pm;
                    }
                    if( result.planes ){
                        const planes = [];
                        result.planes.forEach(function(e){
                            if( e.estado ){
                                const pm = [];
                                if( !e.cobros ) e.cobros = [];
                                e.cobros.forEach(function(c){
                                    //xnombre no deberia ir, mejor era optener el id del tipo de concepto
                                    pm.push( { concepto_pago_id:c.cobro_programa_id,monto:c.monto,cuotas:c.cuotas,xnombre:c.nombre,xdisabled:true,opcional:c.opcional } )
                                })
                                planes.push( {nombre:e.nombre,xestado:true,xplan_cobro_programa_id:e.plan_cobro_programa_id,xnombre:e.nombre,cobros:pm} )
                            }else{
                                vue.cuotasfalse += 1;
                            }
                        })
                        vue.newprograma.planes = planes;
                    }
                }
                vue.loading = false;
            })
            .catch(() => {
                // window.console.log('error', error);
                vue.loading = false;
            });
        },
        formatCode(name,id){
            return `${name.slice(0,1)}-${id}`.toUpperCase();
        },
    },
    mounted(){
        let post = sessionStorage.getItem('xpostgradorest');
        let modi = sessionStorage.getItem('xprogramarest');
        if( post ){
            let ppost = JSON.parse( post );
            if( !ppost.area  ) ppost.area = {};
            this.postgrado = ppost;
        }
        if( modi ){
            let mmm = JSON.parse(modi);
            this.defaultgestion.gestion = mmm.gestion;
            this.modificar.fecha_inicio = mmm.fecha_inicio;
            this.modificar.fecha_fin = mmm.fecha_fin;
            this.getprogramatoedit( mmm.id );
        }
        this.newprograma.posgrado_id = this.postgrado.id;
        this.newprograma.nombre_compuesto = this.postgrado.nombre;
    }
}
</script>